var render, staticRenderFns
import script from "./DashboardPortfolioGrowth.vue?vue&type=script&lang=js&"
export * from "./DashboardPortfolioGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5c786",
  null
  
)

export default component.exports